var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 mb-4" }, [
        _c("div", { staticClass: "card shadow mb-4" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _vm.hasFilters
              ? _c(
                  "div",
                  { staticClass: "row align-items-end mb-3" },
                  _vm._l(_vm.filterCount, function (n) {
                    return _c("div", { key: n, staticClass: "col-md-3" }, [
                      _c("div", {
                        staticClass: "skeleton-box mb-2",
                        staticStyle: { height: "16px", width: "80px" },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "skeleton-box",
                        staticStyle: { height: "38px", width: "100%" },
                      }),
                    ])
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", { staticClass: "table trips-table" }, [
                _c("thead", { staticClass: "thead-light" }, [
                  _c(
                    "tr",
                    [
                      _vm._l(_vm.columnCount, function (n) {
                        return _c("th", { key: n, attrs: { scope: "col" } }, [
                          _c("div", {
                            staticClass: "skeleton-box",
                            staticStyle: { height: "20px", width: "80%" },
                          }),
                        ])
                      }),
                      _vm._v(" "),
                      _vm.hasActions
                        ? _c("th", { attrs: { scope: "col" } }, [
                            _c("div", {
                              staticClass: "skeleton-box",
                              staticStyle: { height: "20px", width: "80px" },
                            }),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.rowCount, function (row) {
                    return _c(
                      "tr",
                      { key: row },
                      [
                        _vm._l(_vm.columnCount, function (col) {
                          return _c("td", { key: col }, [
                            _c("div", {
                              staticClass: "skeleton-box",
                              style: `height: 18px; width: ${_vm.getRandomWidth()}%;`,
                            }),
                          ])
                        }),
                        _vm._v(" "),
                        _vm.hasActions ? _c("td", [_vm._m(1, true)]) : _vm._e(),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm._m(2),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "card-header py-3 d-flex justify-content-between align-items-center",
      },
      [
        _c("div", {
          staticClass: "skeleton-box",
          staticStyle: { height: "24px", width: "150px" },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "skeleton-box",
          staticStyle: {
            height: "36px",
            width: "120px",
            "border-radius": "4px",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex gap-2" }, [
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "32px", width: "32px", "border-radius": "4px" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "32px", width: "32px", "border-radius": "4px" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "skeleton-box",
        staticStyle: { height: "32px", width: "32px", "border-radius": "4px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-footer" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("div", {
            staticClass: "skeleton-box",
            staticStyle: { height: "16px", width: "120px" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex gap-2" }, [
            _c("div", {
              staticClass: "skeleton-box",
              staticStyle: {
                height: "36px",
                width: "36px",
                "border-radius": "4px",
              },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "skeleton-box",
              staticStyle: {
                height: "36px",
                width: "36px",
                "border-radius": "4px",
              },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "skeleton-box",
              staticStyle: {
                height: "36px",
                width: "36px",
                "border-radius": "4px",
              },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "skeleton-box",
              staticStyle: {
                height: "36px",
                width: "36px",
                "border-radius": "4px",
              },
            }),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }